import { render, staticRenderFns } from "./TranslateImageButton.vue?vue&type=template&id=393397d6"
import script from "./TranslateImageButton.vue?vue&type=script&lang=js"
export * from "./TranslateImageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports